import * as suportTicket from "../../types/admin/supportTypes";

export const createSupportTicketReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.CREATE_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.CREATE_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.CREATE_SUPPORT_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getAllSupportTicketReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.GET_ALL_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.GET_ALL_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.GET_ALL_SUPPORT_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getSupportTicketByIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.GET_SUPPORT_TICKET_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.GET_SUPPORT_TICKET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.GET_SUPPORT_TICKET_BY_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateSupportTicketReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.UPDATE_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.UPDATE_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.UPDATE_SUPPORT_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const createSupportMessageReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.CREATE_SUPPORT_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.CREATE_SUPPORT_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.CREATE_SUPPORT_MESSAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};
export const getSupportMessageByTicketIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };

    case suportTicket.CREATE_SUPPORT_MESSAGE_SUCCESS:
      return {
        ...state,
        info: state.info ? [...state.info, payload] : [payload],
      };

    case suportTicket.GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};
export const getAllCompanySupportTicketReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case suportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case suportTicket.GET_ALL_COMPANY_SUPPORT_TICKET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

// ADMIN SPECIFIC REDUCERS FOR SUPPORT DETAILS
export const adminGetSupportTicketByIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_REQUEST:
      return { ...state, loading: true };
    case suportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_SUCCESS:
      return { ...state, loading: false, info: payload, error: "" };
    case suportTicket.ADMIN_GET_SUPPORT_TICKET_BY_ID_FAIL:
      return { ...state, loading: false, error: payload, info: null };
    default:
      return state;
  }
};

export const adminGetSupportMessageByTicketIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_REQUEST:
      return { ...state, loading: true };
    case suportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_SUCCESS:
      return { ...state, loading: false, info: payload, error: "" };
    case suportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_SUCCESS:
      return {
        ...state,
        info: Array.isArray(state.info) ? [...state.info, payload] : [payload],
      };
    case suportTicket.ADMIN_GET_ALL_MESSAGE_BY_SUPPORT_TICKET_ID_FAIL:
      return { ...state, loading: false, error: payload, info: null };
    default:
      return state;
  }
};

export const adminCreateSupportMessageReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_REQUEST:
      return { ...state, loading: true };
    case suportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_SUCCESS:
      return { ...state, loading: false, info: payload, error: "" };
    case suportTicket.ADMIN_CREATE_SUPPORT_MESSAGE_FAIL:
      return { ...state, loading: false, error: payload, info: null };
    default:
      return state;
  }
};

export const adminUpdateSupportTicketReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case suportTicket.ADMIN_UPDATE_SUPPORT_TICKET_REQUEST:
      return { ...state, loading: true };
    case suportTicket.ADMIN_UPDATE_SUPPORT_TICKET_SUCCESS:
      return { ...state, loading: false, info: payload, error: "" };
    case suportTicket.ADMIN_UPDATE_SUPPORT_TICKET_FAIL:
      return { ...state, loading: false, error: payload, info: null };
    default:
      return state;
  }
};
